var map = {
	"./asset-hyperlink.json": 23502,
	"./blockquote.json": 97784,
	"./document.json": 94634,
	"./embedded-asset-block.json": 96188,
	"./embedded-entry-block.json": 74160,
	"./embedded-entry-inline.json": 33290,
	"./embedded-resource-block.json": 97904,
	"./embedded-resource-inline.json": 27242,
	"./entry-hyperlink.json": 40830,
	"./heading-1.json": 82713,
	"./heading-2.json": 33036,
	"./heading-3.json": 58399,
	"./heading-4.json": 21634,
	"./heading-5.json": 18317,
	"./heading-6.json": 62800,
	"./hr.json": 28381,
	"./hyperlink.json": 61203,
	"./list-item.json": 34421,
	"./ordered-list.json": 13867,
	"./paragraph.json": 86311,
	"./resource-hyperlink.json": 7272,
	"./table-cell.json": 85156,
	"./table-header-cell.json": 28132,
	"./table-row.json": 53388,
	"./table.json": 45825,
	"./text.json": 54084,
	"./unordered-list.json": 51464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85152;